"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ActionButton = function ActionButton(_ref) {
  var level = _ref.level,
      disabled = _ref.disabled,
      children = _ref.children,
      fullwidth = _ref.fullwidth,
      onClick = _ref.onClick,
      icon = _ref.icon,
      className = _ref.className,
      padding = _ref.padding,
      tooltipText = _ref.tooltipText,
      otherProps = _objectWithoutProperties(_ref, ["level", "disabled", "children", "fullwidth", "onClick", "icon", "className", "padding", "tooltipText"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setIsActive = _useState2[1];

  var handleClick = function handleClick(e) {
    if (!disabled) {
      onClick(e);
    }
  };

  return tooltipText ? /*#__PURE__*/_react.default.createElement(ListenerWrapper, {
    onMouseEnter: function onMouseEnter() {
      return tooltipText && setIsActive(true);
    },
    onMouseLeave: function onMouseLeave() {
      return tooltipText && setIsActive(false);
    },
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(TooltipContent, {
    active: isActive
  }, tooltipText), /*#__PURE__*/_react.default.createElement(StyledButton, _extends({
    level: level,
    onClick: handleClick,
    fullwidth: fullwidth,
    disabled: disabled,
    padding: padding,
    className: className,
    tooltipText: tooltipText
  }, otherProps), icon ? /*#__PURE__*/_react.default.createElement(Image, {
    src: icon
  }) : null, children)) : /*#__PURE__*/_react.default.createElement(StyledButton, _extends({
    level: level,
    onClick: handleClick,
    fullwidth: fullwidth,
    disabled: disabled,
    padding: padding,
    className: className
  }, otherProps), icon ? /*#__PURE__*/_react.default.createElement(Image, {
    src: icon
  }) : null, children);
};

var ListenerWrapper = _styledComponents.default.div.withConfig({
  displayName: "ListenerWrapper"
})(["display:flex;position:relative;z-index:9;cursor:", ";"], function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? 'not-allowed' : 'pointer';
});

var TooltipContent = _styledComponents.default.div.withConfig({
  displayName: "TooltipContent"
})(["visibility:", ";z-index:9;position:absolute;bottom:100%;left:50%;opacity:", ";margin-bottom:1em;padding:1em;background-color:#11141c;width:300px;border-radius:5px;transform:", ";font-family:", ";transition:all 0.2s ease;font-size:14px;line-height:120%;color:white;&::before{content:'';position:absolute;top:100%;left:50%;width:0;height:0;border:0.5em solid transparent;border-top-color:#11141c;-webkit-transform:translate(-50%,0);transform:translate(-50%,0);}"], function (_ref3) {
  var active = _ref3.active;
  return active ? 'visible' : 'hidden';
}, function (_ref4) {
  var active = _ref4.active;
  return active ? '1' : '0';
}, function (_ref5) {
  var active = _ref5.active;
  return active ? 'translate(-50%, 0)' : 'translate(-50%, 1em)';
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.font;
});

var StyledButton = _styledComponents.default.button.withConfig({
  displayName: "StyledButton"
})(["&[disabled]{pointer-events:", ";}font-family:", ";font-size:1.6rem;border-radius:0.5rem;min-width:14rem;width:", ";height:4rem;transition:0.1s ease-in-out;display:flex;justify-content:center;align-items:center;background-color:", ";color:", ";border:", ";padding:", ";cursor:", ";:active{transform:scale(0.95);}:focus{outline:none;}:hover{background-color:", ";color:", ";}"], function (_ref7) {
  var tooltipText = _ref7.tooltipText;
  return tooltipText ? 'none' : 'auto';
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.font;
}, function (props) {
  return props.fullwidth ? '100%' : '';
}, function (_ref9) {
  var theme = _ref9.theme,
      disabled = _ref9.disabled,
      level = _ref9.level;
  return disabled && level === 'primary' ? theme.ui.disabled : disabled && level === 'secondary' || level === 'secondary' ? 'transparent' : level === 'primary' ? theme.brand.primary : level === 'default' ? theme.ui.interactive : level === 'white' ? 'white' : theme.brand.primary;
}, function (_ref10) {
  var theme = _ref10.theme,
      disabled = _ref10.disabled,
      level = _ref10.level;
  return disabled && level === 'primary' || level === 'primary' || level === 'default' ? 'white' : disabled && level === 'secondary' ? theme.ui.disabled : level === 'secondary' ? theme.brand.primary : level === 'white' ? '#222' : 'white';
}, function (_ref11) {
  var theme = _ref11.theme,
      disabled = _ref11.disabled,
      level = _ref11.level;
  return disabled && level === 'primary' || level === 'primary' || level === 'default' ? '0' : disabled && level === 'secondary' ? "2px solid ".concat(theme.ui.disabled) : level === 'secondary' ? "2px solid ".concat(theme.brand.primary) : '0';
}, function (_ref12) {
  var padding = _ref12.padding;
  return padding || '1rem 0.4rem';
}, function (_ref13) {
  var disabled = _ref13.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref14) {
  var theme = _ref14.theme,
      level = _ref14.level,
      disabled = _ref14.disabled;
  return disabled ? theme.ui.disabled : level === 'primary' ? theme.brand.light : level === 'secondary' ? theme.brand.primary : level === 'default' ? theme.ui.disabled : '';
}, function (_ref15) {
  var theme = _ref15.theme,
      level = _ref15.level;
  return level === 'white' ? theme.brand.primary : 'white';
});

var Image = _styledComponents.default.img.withConfig({
  displayName: "Image"
})(["margin-right:1rem;height:2rem;"]);

ActionButton.defaultProps = {
  disabled: false,
  level: 'primary',
  fullwidth: false,
  icon: null,
  onClick: function onClick() {
    console.log('clicked button');
  },
  otherProps: {}
};
ActionButton.propTypes = {
  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** If true button is disabled */
  disabled: _propTypes.bool,

  /** The color theme */
  level: _propTypes.string,

  /** The label of the button */
  children: _propTypes.node.isRequired,

  /** If true button width is 100% */
  fullwidth: _propTypes.bool,

  /** Triggered when button is clicked */
  onClick: _propTypes.func.isRequired,
  padding: _propTypes.string,

  /** Adds icon to button */
  icon: _propTypes.node,

  /** Text for the tooltip when hovering */
  tooltipText: _propTypes.string,

  /** Adds extra props to the element */
  otherProps: _propTypes.object
};
var _default = ActionButton;
exports.default = _default;